export default {
  "menu.welcome": "Home",
  "menu.more-blocks": "More Blocks",
  "menu.home": "Home",
  "menu.admin": "Admin",
  "menu.admin.sub-page": "Sub-Page",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "Analysis",
  "menu.dashboard.monitor": "Monitor",
  "menu.dashboard.workplace": "Workplace",
  "menu.clear-static-cache": "Clear Site cache",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "Form",
  "menu.form.basic-form": "Basic Form",
  "menu.form.step-form": "Step Form",
  "menu.form.step-form.info": "Step Form(write transfer information)",
  "menu.form.step-form.confirm": "Step Form(confirm transfer information)",
  "menu.form.step-form.result": "Step Form(finished)",
  "menu.form.advanced-form": "Advanced Form",
  "menu.list": "List",
  "menu.bonus-admin": "Bonus Admin",
  "menu.bonus-admin.deposit-bonus-admin": "Deposit Bonus Admin",
  "menu.bonus-admin.promotions-admin": "Promotions Admin",
  "menu.list.table-list": "Search Table",
  "menu.list.basic-list": "Basic List",
  "menu.list.card-list": "Card List",
  "menu.list.search-list": "Search List",
  "menu.list.search-list.articles": "Search List(articles)",
  "menu.list.search-list.projects": "Search List(projects)",
  "menu.list.search-list.applications": "Search List(applications)",
  "menu.profile": "Profile",
  "menu.profile.basic": "Basic Profile",
  "menu.profile.advanced": "Advanced Profile",
  "menu.result": "Result",
  "menu.result.success": "Success",
  "menu.result.fail": "Fail",
  "menu.exception": "Exception",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger",
  "menu.account": "Account",
  "menu.account.center": "Account Center",
  "menu.account.settings": "Account Settings",
  "menu.account.trigger": "Trigger Error",
  "menu.account.logout": "Logout",
  "menu.editor": "Graphic Editor",
  "menu.editor.flow": "Flow Editor",
  "menu.editor.mind": "Mind Editor",
  "menu.editor.koni": "Koni Editor",
  "menu.order-list.title": "Order List",
  "menu.topup-list.title": "TopUp List",
  "menu.user-admin": "User Admin",
  "menu.user-admin.user-list": "User List",
  "menu.user-admin.user-risk-admin": "User Risk Admin",
  "menu.user-admin.user-tags-admin": "User Tags Admin",
  "menu.user-admin.user-group-admin": "User Group Admin",
  "menu.user-admin.user-vip-admin": "User VIP Admin",
  "menu.user-admin.user-retain": "User Retain",
  "menu.user-list": "User List",
  "menu.report-lists": "Report Lists",
  "menu.report-lists.bet-order": "Bet Order",
  "menu.report-lists.bet-reports": "Bet Reports",
  "menu.report-lists.wallet-change-list": "Wallet Change List",
  "menu.report-lists.deposit-record": "Deposit Record",
  "menu.report-lists.ltv": "LTV",
  "menu.report-lists.k-factor": "K-Factor",
  "menu.report-lists.retention-rate": "Retention Rate",
  "menu.report-lists.bonus-record": "Bonus Record",
  "menu.agent-admin": "Agent Admin",
  "menu.agent-admin.agent-approval": "Agent Approval",
  "menu.agent-admin.agent-approval-history": "Approval History",
  "menu.agent-admin.agent-details": "Agent Details",
  "menu.agent-admin.agent-report": "Agent Report",
  "menu.agent-admin.agent-cashback-admin": "Agent Cashback Admin",
  "menu.financial-statements": "Financial Statements",
  "menu.financial-statements.deposit-record": "Deposit Record",
  "menu.operational-report": "Operational Report",
  "menu.operational-report.bet-order": "Bet Order",
  "menu.operational-report.bet-reports": "Bet Reports",
  "menu.operational-report.wallet-change-list": "Wallet Change List",
  "menu.operational-report.luck-wheel-daily-statistics-report":
    "Luck Wheel Daily Statistics Report",
  "menu.operational-report.ltv": "LTV",
  "menu.operational-report.k-factor": "K-Factor",
  "menu.operational-report.retention-rate": "Retention Rate",
  "menu.operational-report.bonus-record": "Bonus Record",
  "menu.game-admin": "Game Admin",
  "menu.game-admin.games-manage": "Games Management",
  "menu.game-admin.game-actions": "Game Actions",
  "menu.game-admin.tags-admin": "Tags Admin",
  "menu.withdraw-admin": "Withdraw Admin",
  "menu.withdraw-admin.withdraw-approval": "Withdraw Approval",
  "menu.withdraw-admin.withdraw-history": "Withdraw History",
  "menu.withdraw-admin.member-deposits": "Member Deposits",
  "menu.operations-section": "Operations Section",
  "menu.report-section": "Reports Section",
  "menu.config-section": "Configuration Section",
  "menu.config-admin": "Config Admin",
  "menu.config-admin.betting-analysis": "Betting Analysis",
  "menu.config-admin.adjust-app-config": "AdjustAPPConfig",
  "menu.config-admin.about-admin": "About Admin",
  "menu.config-admin.left-menu-admin": "Left Menu Admin",
  "menu.config-admin.pixels-management": "Pixels Management",
  "menu.config-admin.airdrop-config": "Airdrop Config",
  "menu.config-admin.email-marketing": "Email Marketing",
  "menu.config-admin.valid-bet-config": "Valid Bet Config",
  "menu.statistical-reports": "Statistical Reports",
  "menu.message-admin": "Message Admin",
  "menu.bonus-admin": "Bonus Admin",
  "menu.bonus-admin.bonus-list": "Bonus List",
  "menu.bonus-admin.redemption-code": "Redemption Code",
  "menu.bonus-admin.checkin-config": "Checkin Config",
  "menu.bonus-admin.free-spin-config": "Free Spin Config",
  "menu.bonus-admin.luckywheel-config": "Luckywheel Config",
  "menu.bonus-admin.activity-bonus": "Activity Bonus",
  "menu.bonus-admin.daily-rebate-admin": "Daily Rebate Admin",
  "menu.bonus-admin.invite-box-admin": "Invite Box Admin",
  "menu.bonus-admin.task-admin": "Task Admin",
  "menu.betting-analysis": "Betting Analysis",
  "menu.betting-analysis.betting-analysis": "Betting Analysis",
  "menu.redemption-code": "Redemption Code",
  "menu.redemption-code.config-list": "Redemption Code Config",
  "menu.redemption-code.record": "Redemption Code Record",
  "menu.checkin-admin": "Checkin Admin",
  "menu.checkin-admin.config-list": "Checkin Config",
  "menu.checkin-admin.checkin-record": "Checkin Record",
  "menu.gem-mall-admin": "Gem Mall Admin",
  "menu.gem-mall-admin.goods-type-admin": "Goods Type Admin",
  "menu.gem-mall-admin.goods-admin": "Goods Management",
  "menu.gem-mall-admin.exchange-mall-admin": "Exchange Mall",
  "menu.gem-mall-admin.exchange-tags-admin": "Exchange Tags Admin",
  "menu.payment-admin": "Payment Admin",
  "menu.payment-admin.payment-platform-admin": "Payment Platform Admin",
  "menu.free-spin-admin": "Free Spin Admin",
  "menu.free-spin-admin.config": "Free Spin Config",
  "menu.free-spin-admin.free-spin-config": "Free Spin Config",
  "menu.free-spin-admin.free-spin-record": "Free Spin Record",
  "menu.free-spin-admin.record": "Free Spin Record",
  "menu.luckywheel-admin": "Lucky Wheel Admin",
  "menu.luckywheel-admin.luckywheel-config": "Lucky Wheel Config",
  "menu.record-admin.luckywheel-record": "Lucky Wheel Record",
  "menu.record-admin.login-history": "Login History",
  "menu.record-admin.operation-record": "Operation Record",
  "menu.bonus-admin.luckydraw-config": "Lucky Draw Config",
  "menu.luckywheel-admin.luckywheel-record": "Lucky Wheel Record",
  "menu.luckywheel-admin.luckywheel-daily-report": "Lucky Wheel Daily Report",
  "menu.activity-bonus": "Activity Bonus",
  "menu.activity-bonus.config-list": "Activity Bonus Config",
  "menu.pwa-notification-admin": "PWA Notification Admin",
  "menu.pwa-notification-admin.pwa-device-list": "PWA Device List",
  "menu.pwa-notification-admin.pwa-notification-list": "PWA Notification List",
  "menu.pwa-notification-admin.pwa-notification-task-list":
    "PWA Notification Task List",
  "menu.statistical-reports.retention-rate": "Retention Rate",
  "menu.statistical-reports.retention-rate-report":
    "Retention Rate (Bet + Deposit口径)",
  "menu.statistical-reports.retention-rate-deposit":
    "Retention Rate (Deposit口径)",
  "menu.statistical-reports.k-factor": "K-Factor Report",
};
